// 로그인 뒤 돌아갈 경로를 검사한다. 이 사이트 안의 경로만 받고, 아니면 "/"다.

const BASE = "http://muse.invalid";
// 제어 문자(탭·줄바꿈 포함)는 URL 파서가 지워서 "/\t/evil.com"이 "//evil.com"이 된다
// biome-ignore lint/suspicious/noControlCharactersInRegex: 제어 문자를 막으려는 검사다
const CONTROL_CHARS = /[\u0000-\u001f\u007f]/;

export function safeNextPath(next: string | null | undefined): string {
  if (next === null || next === undefined || next === "" || !next.startsWith("/")) return "/";
  if (CONTROL_CHARS.test(next)) return "/";
  let url: URL;
  try {
    url = new URL(next, BASE);
  } catch {
    return "/";
  }
  if (url.origin !== BASE) return "/";
  // 로그인 화면으로 돌아오면 로그인한 사람이 로그인 화면에 머문다
  if (url.pathname === "/login" || url.pathname.startsWith("/login/")) return "/";
  const result = url.pathname + url.search + url.hash;
  // 점 구간이 접히면 "/..//evil.com"이 "//evil.com"이 된다. 슬래시 하나로 시작하는 경로만 받는다
  if (!result.startsWith("/") || result.startsWith("//") || result.startsWith("/\\")) return "/";
  return result;
}
